
export const kAppointmentTimeIncrement = 5; // DO NOT CHANGE THIS VALUE. THE APP WILL BREAK.
export const kUnlimitedSlots = -1; // DO NOT CHANGE THIS VALUE. THE APP WILL BREAK.
export const kGenericBlurHash = 'K2P?:h%M_3-;fQof~qfQ4n';
export const kMinutesPerHour = 60;
export const kDaysPerWeek = 7;
export const kHoursPerDay = 24;
export const kMinutesPerDay = kHoursPerDay * kMinutesPerHour;
export const kMillisecondsPerMinute = 60 * 1000;
export const kEarthRadius = 6371e3;
export const kMillisecondsPerHour: number = kMillisecondsPerMinute * 60;
export const kMaxServiceQuantity = 3;
